import React, { useEffect, useState, useMemo } from 'react';
import {
  Users, ChevronLeft, ChevronRight,
  Shield, UserCheck, AlertCircle, ChevronsLeft,
  Settings, Menu, Download,
  UserX, ChevronsRight, X,
  Bell, ChevronDown,
  Search,
  Clock, Edit,
  LogOut,HelpCircle,
  Key,
  Lock,
  AlertTriangle,
  BarChart,
  Globe, CheckCircle,
  FileText,
  UserPlus,
  Filter,
  RefreshCw,
  Trash2,
} from 'lucide-react';
import AddUserModal from './AddUserModal';
import Avatar from '../../../services/Avatar';
import UserEditModal from './EditUserModel';
import LogMonitoring from './LogMonitoring';
import axios from 'axios'; 


const authData = {  
  topApplications: [
    { name: 'Sales CRM', users: 342, growth: 4.2 },
    { name: 'HR Portal', users: 287, growth: 1.7 },
    { name: 'Finance Dashboard', users: 201, growth: -0.8 },
    { name: 'Engineering Tools', users: 176, growth: 2.5 },
  ],
  notifications: [
    { id: 1, type: 'alert', message: 'Multiple failed login attempts detected', time: '12 minutes ago' },
    { id: 2, type: 'info', message: 'System update scheduled for tonight at 2:00 AM', time: '1 hour ago' },
    { id: 3, type: 'success', message: 'New user directory integration completed', time: '3 hours ago' },
  ],
  helpTopics: [
    { title: 'Setting up Multi-Factor Authentication', link: '#mfa-setup' },
    { title: 'Managing User Permissions', link: '#user-permissions' },
    { title: 'Configuring SSO for New Applications', link: '#sso-config' },
    { title: 'Audit Log Report Generation', link: '#audit-reports' },
  ]
};

const SSOAdminPanel = () => {
  const [activeSection, setActiveSection] = useState('dashboard');
  const [searchQuery, setSearchQuery] = useState('');
   const [itemsPerPage, setItemsPerPage] = useState(5);
  const [users, setUsers] = useState([]); // Users data from the server
  const [summaryStats, setSummaryStats] = useState({}); // Stats for active users, failed logins, etc.
  const [filterOptions, setFilterOptions] = useState({
      status: 'all', // all, success, failed
      timeRange: '24h', // 24h, 7d, 30d
      sortBy: 'timestamp', // timestamp, user, status
      sortDirection: 'desc' // asc, desc
    });

  const [refreshInterval, setRefreshInterval] = useState(300);
  const [currentUser, setCurrentUser] = useState('');
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterActive, setFilterActive] = useState('all');
  const [pageSize] = useState(10);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [logData, setLogData] = useState([]);
  const [availableRoles, setAvailableRoles] = useState([]);
  const [availableTools, setAvailableTools] = useState([]);

  const [isRefreshing, setIsRefreshing] = useState(false);
  const [activeNavItem, setActiveNavItem] = useState(null);
    
    const toggleSidebar = () => {
      setSidebarCollapsed(!sidebarCollapsed);
    };
    
    const handleRefresh = () => {
      setIsRefreshing(true);
      setTimeout(() => setIsRefreshing(false), 1500);
    };
    
    const toggleNotifications = () => {
      setActiveNavItem(activeNavItem === 'notifications' ? null : 'notifications');
    };
    
    const toggleHelp = () => {
      setActiveNavItem(activeNavItem === 'help' ? null : 'help');
    };

    //console.log("summaryStats", summaryStats);
    
    const menuItems = [
      { id: 'dashboard', icon: <BarChart size={20} />, label: 'Dashboard' },
      { id: 'users', icon: <Users size={20} />, label: 'User Management' },
      { id: 'audit', icon: <FileText size={20} />, label: 'Audit Logs' },
      { id: 'applications', icon: <Globe size={20} />, label: 'Applications' },
      { id: 'security', icon: <Shield size={20} />, label: 'Security' },      
      { id: 'settings', icon: <Settings size={20} />, label: 'Settings' }
    ];
   
    const [loading, setLoading] = useState(true);
    
    const fetchCurrentUser = async () => {
      try {
        const response = await axios.get('/api/sso-users/me', { withCredentials: true }); 
        setCurrentUser(response.data); // Update state with user data
      } catch (error) {
        //console.error('Error fetching current user:', error);
      }
    };

     // Function to fetch login activity and summary data
  const fetchActivityAndSummary = async () => {
    try {
      const [activityResponse, summaryResponse] = await Promise.all([
        axios.get('/api/sso-login-activity', { withCredentials: true }),
        //axios.get('/sso-summary', { withCredentials: true })
      ]);
      setLogData(activityResponse.data.data || []);
      setSummaryStats(summaryResponse.data || {});
    } catch (error) {
      //console.error('Error fetching login activity or summary:', error);
    } finally {
      setLoading(false);
    }
  };


  // Combined useEffect for fetching current user and initial activity/summary data
  useEffect(() => {
    fetchCurrentUser();
    fetchActivityAndSummary();

    // Set up auto-refresh based on refreshInterval
    const interval = setInterval(() => {
      fetchCurrentUser();
      fetchActivityAndSummary();
    }, refreshInterval * 1000); // Convert seconds to milliseconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, [refreshInterval]); // dependency on refreshInterval to reset interval when it changes

  // Fetch user data with pagination and filters
  const fetchData = async () => {
    try {
      const response = await axios.get('/api/sso-users', {
        params: {
          page: currentPage,
          size: pageSize,
          filter: filterActive,
          search: searchTerm
        },
        withCredentials: true,
      });
      setUsers(response.data.data || []);
      setSummaryStats(response.data.summary);
      setAvailableRoles(response.data.roles || []);
      setAvailableTools(response.data.tools || []);
    } catch (error) {
      //console.error('Error fetching user data:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, filterActive]); // Fetch users when currentPage or filterActive changes

  const handleLogout = async () => {
    try {
      const response = await fetch('/d-auth/logout', {
        method: 'POST', // or 'GET', depending on your backend implementation
        credentials: 'include', // include cookies with the request
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {       
        
        window.location.href = '/'; 
      } else {
        // If there's an error during logout
        const errorData = await response.json();
        //console.error('Logout failed', errorData);
        alert( errorData ||'Logout failed. Please try again.');
      }
    } catch (error) {
      //console.error('Error during logout:', error);
      alert('An error occurred. Please try again.');
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    fetchData();
  };

  // Add these state variables to your component:
const [isEditModalOpen, setIsEditModalOpen] = useState(false);


// Add this function to handle opening the edit modal:
const handleEditUser = (user) => {
  setCurrentUser(user);
  setIsEditModalOpen(true);
};

const handleSaveUser = async (userData) => {
  try {
    const response = await fetch('/api/SSO/users/update', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userData), // includes id
    });

    const result = await response.json();

    if (response.ok) {
      setUsers(users.map(user =>
        user.id === userData.id ? { ...user, ...userData } : user
      ));
      setIsEditModalOpen(false);
      alert("User updated successfully!");
    } else {
      alert(result.error || 'Failed to update user');
    }
  } catch (error) {
    //console.error('Error updating user:', error);
   alert('An error occurred while updating the user.');
  }
};



  /*const handleSaveUser = async (updatedUser) => {
    // Implement your API call to save the user
    try {
      const response = await fetch(`/api/users/${editingUser.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedUser),
      });
      
      if (!response.ok) throw new Error('Failed to update user');
      
      // Refresh your users data or update the specific user in state
    } catch (error) {
      throw error;
    }
  };*/

  

      
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

// Function to show an alert and handle the reset password action
const handleResetPassword = async (userId) => {
  if (window.confirm('Are you sure you want to reset the password for this user?')) {
      try {
          const response = await axios.post('/api/sso-users/reset-password', { userId });
          if (response.status === 200) {
              setShowSuccess(true);
              // Use dynamic message from server if available
              setSuccessMessage(response.data.message || 'Password reset email sent successfully.');
              setTimeout(() => {
                  setSuccessMessage("");
              }, 5000);  
          }
      } catch (error) {
          setShowError(true);
          // Check if the error response has a message
          const errorMsg = error.response?.data?.error || 'Failed to reset password.';
          setErrorMessage(errorMsg);
          setTimeout(() => {
              setErrorMessage("");
          }, 5000);
      }
  }
};

// Function to terminate session
const handleTerminateSession = async (userId) => {
  if (window.confirm('Are you sure you want to terminate this session?')) {
      try {
          const response = await axios.post('/api/sso-users/terminate-session', { userId });
          if (response.status === 200) {
              setShowSuccess(true);
              // Use dynamic message from server if available
              setSuccessMessage(response.data.message || 'Session terminated successfully.');
              setTimeout(() => {
                  setSuccessMessage("");
              }, 5000);  
          }
      } catch (error) {
          setShowError(true);
          // Check if the error response has a message
          const errorMsg = error.response?.data?.error || 'Failed to terminate session.';
          setErrorMessage(errorMsg);
          setTimeout(() => {
              setErrorMessage("");
          }, 5000);
      }
  }
};

// Function to delete user
const handleDeleteUser = async (userId) => {
  if (window.confirm('Are you sure you want to delete this user? This action cannot be undone.')) {
      try {
          const response = await axios.post('/api/sso-users/delete-user', { userId });
          if (response.status === 200) {
              setShowSuccess(true);
              // Use dynamic message from server if available
              setSuccessMessage(response.data.message || 'User deleted successfully.');
              setTimeout(() => {
                  setSuccessMessage("");
              }, 5000);                 
          }
      } catch (error) {
          setShowError(true);
          // Check if the error response has a message
          const errorMsg = error.response?.data?.error || 'Failed to delete user.';
          setErrorMessage(errorMsg);
          setTimeout(() => {
              setErrorMessage("");
          }, 5000);
      }
  }
};

  
   
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };


    // Advanced filtering and sorting logic
      const filteredAndSortedLogs = useMemo(() => {
        // First filter by search query across multiple fields
        let filtered = logData.filter(log => {
          if (!searchQuery) return true;
          
          const query = searchQuery.toLowerCase();
          return (
            log.user.toLowerCase().includes(query) ||
            log.ip_address.toLowerCase().includes(query) ||
            log.browser.toLowerCase().includes(query) ||
            log.operating_system.toLowerCase().includes(query) ||
            log.location?.toLowerCase().includes(query) ||
            log.auth_method?.toLowerCase().includes(query)
          );
        });
        
        // Apply status filter
        if (filterOptions.status !== 'all') {
          filtered = filtered.filter(log => 
            filterOptions.status === 'success' ? log.success : !log.success
          );
        }
        
        // Apply time range filter
        const now = new Date();
        let timeThreshold = now;
        
        switch (filterOptions.timeRange) {
          case '24h':
            timeThreshold = new Date(now.getTime() - 24 * 60 * 60 * 1000);
            break;
          case '7d':
            timeThreshold = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
            break;
          case '30d':
            timeThreshold = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
            break;
          default:
            break;
        }
        
        filtered = filtered.filter(log => new Date(log.timestamp) >= timeThreshold);
        
        // Sort the filtered logs
        filtered.sort((a, b) => {
          let aValue, bValue;
          
          switch (filterOptions.sortBy) {
            case 'user':
              aValue = a.user;
              bValue = b.user;
              break;
            case 'status':
              aValue = a.success ? 1 : 0;
              bValue = b.success ? 1 : 0;
              break;
            case 'timestamp':
            default:
              aValue = new Date(a.timestamp).getTime();
              bValue = new Date(b.timestamp).getTime();
              break;
          }
          
          // Apply sort direction
          return filterOptions.sortDirection === 'asc' 
            ? aValue > bValue ? 1 : -1
            : aValue < bValue ? 1 : -1;
        });
        
        return filtered;
      }, [logData, searchQuery, filterOptions]);
      
      // Pagination logic
      const paginatedLogs = useMemo(() => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        return filteredAndSortedLogs.slice(startIndex, startIndex + itemsPerPage);
      }, [filteredAndSortedLogs, currentPage, itemsPerPage]);
      
      const totalPages = Math.ceil(filteredAndSortedLogs.length / itemsPerPage);
      
      // Calculate trend indicators for stats
      const getTrendIndicator = (value, threshold = 0) => {
        if (value > threshold) {
          return <span className="text-green-400 text-xs ml-1">↑</span>;
        } else if (value < threshold) {
          return <span className="text-red-400 text-xs ml-1">↓</span>;
        }
        return null;
      };

      // Enhanced time formatting with relative and absolute time
  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const seconds = Math.floor((now - date) / 1000);
    
    // Relative time (human-readable)
    let relativeTime;
    if (seconds < 60) {
      relativeTime = `${seconds} seconds ago`;
    } else if (seconds < 3600) {
      relativeTime = `${Math.floor(seconds / 60)} minutes ago`;
    } else if (seconds < 86400) {
      relativeTime = `${Math.floor(seconds / 3600)} hours ago`;
    } else {
      relativeTime = `${Math.floor(seconds / 86400)} days ago`;
    }
    
    // Absolute time (for tooltip)
    const absoluteTime = new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: true
    }).format(date);
    
    return { relativeTime, absoluteTime };
  };

      // Get appropriate status styling based on success state and additional context
        const getStatusDisplay = (log) => {
          if (log.status == "Success") {
            return {
              badgeClass: 'bg-green-900 text-green-300 border border-green-700',
              text: 'Success',
              icon: null
            };
          } else {
            // Determine type of failure (could be expanded with more logic)
            const isHighRisk = log.ip_address.startsWith('0.0.0.0'); 
            
            return {
              badgeClass: isHighRisk 
                ? 'bg-red-900 text-red-300 border border-red-700 animate-pulse' 
                : 'bg-red-900 text-red-300 border border-red-700',
              text: 'Failed',
              icon: <AlertTriangle size={16} className="text-yellow-400" />
            };
          }
        };

   // Notification dropdown panel
    const renderNotificationPanel = () => (
      <div className="absolute right-0 top-14 mt-2 w-80 bg-gray-800 rounded-md shadow-lg border border-gray-700 z-50">
        <div className="flex items-center justify-between p-4 border-b border-gray-700">
          <h3 className="font-medium text-white">Notifications</h3>
          <button className="text-sm text-blue-400 hover:text-blue-300">Mark all as read</button>
        </div>
        <div className="max-h-96 overflow-y-auto">
          {authData.notifications.map((notification, i) => (
            <div key={i} className="p-4 border-b border-gray-700 hover:bg-gray-700">
              <div className="flex">
                <div className="mr-3">
                  {notification.type === 'alert' && (
                    <div className="w-8 h-8 bg-red-500 bg-opacity-20 rounded-full flex items-center justify-center">
                      <AlertTriangle size={16} className="text-red-400" />
                    </div>
                  )}
                  {notification.type === 'info' && (
                    <div className="w-8 h-8 bg-blue-500 bg-opacity-20 rounded-full flex items-center justify-center">
                      <Bell size={16} className="text-blue-400" />
                    </div>
                  )}
                  {notification.type === 'success' && (
                    <div className="w-8 h-8 bg-green-500 bg-opacity-20 rounded-full flex items-center justify-center">
                      <CheckCircle size={16} className="text-green-400" />
                    </div>
                  )}
                </div>
                <div className="flex-1">
                  <p className="text-white text-sm">{notification.message}</p>
                  <p className="text-gray-400 text-xs mt-1">{notification.time}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="p-4 text-center">
          <button className="text-blue-400 hover:text-blue-300 text-sm">View all notifications</button>
        </div>
      </div>
    );
    
    // Help panel
    const renderHelpPanel = () => (
      <div className="absolute right-0 top-14 mt-2 w-80 bg-gray-800 rounded-md shadow-lg border border-gray-700 z-50">
        <div className="p-4 border-b border-gray-700">
          <h3 className="font-medium text-white">Help Center</h3>
        </div>
        <div className="p-4">
          <div className="mb-4">
            <div className="relative">
              <input
                type="text"
                placeholder="Search help topics..."
                className="w-full bg-gray-700 text-gray-200 pl-10 pr-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <Search size={16} className="absolute left-3 top-2.5 text-gray-400" />
            </div>
          </div>
          <div className="mb-4">
            <h4 className="text-gray-300 text-sm font-medium mb-2">Popular topics</h4>
            <ul className="space-y-2">
              {authData.helpTopics.map((topic, i) => (
                <li key={i}>
                  <a href={topic.link} className="text-blue-400 hover:text-blue-300 text-sm block py-1">
                    {topic.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="bg-blue-900 bg-opacity-30 p-4 rounded-md border border-blue-800">
            <h4 className="text-white text-sm font-medium mb-1">Need personalized help?</h4>
            <p className="text-gray-300 text-xs mb-2">Our support team is available 24/7</p>
            <button className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-md text-sm transition-colors">
              Contact Support
            </button>
          </div>
        </div>
      </div>
    );

  
  const AuthLogDashboard = () => {
  
    // Custom Card component
      const StatCard = ({ title, value, icon, color, trend, subtext }) => (
        <div className="bg-gray-800 p-5 rounded-lg border border-gray-700 shadow-lg transition-all duration-200 hover:shadow-xl hover:translate-y-[-2px]">
          <div className="flex items-center justify-between">
            <div>
              <div className="text-gray-400 text-sm font-medium mb-1">{title}</div>
              <div className={`text-2xl font-bold ${color}`}>
                {value}
                {trend && getTrendIndicator(trend)}
              </div>
              {subtext && <div className="text-xs text-gray-500 mt-1">{subtext}</div>}
            </div>
            <div className={`p-3 rounded-lg bg-opacity-20 ${color.replace('text', 'bg')}`}>
              {icon}
            </div>
          </div>
        </div>
      );
      
      // Custom Button component
      const Button = ({ children, variant = 'primary', size = 'md', onClick, className = '', icon }) => {
        const baseClasses = 'rounded-md font-medium transition-colors duration-200 flex items-center justify-center';
        
        const variantClasses = {
          primary: 'bg-blue-600 hover:bg-blue-700 text-white',
          secondary: 'bg-gray-700 hover:bg-gray-600 text-white',
          ghost: 'bg-transparent hover:bg-gray-700 text-gray-300'
        };
        
        const sizeClasses = {
          sm: 'text-xs px-2 py-1',
          md: 'text-sm px-3 py-2',
          lg: 'text-base px-4 py-2'
        };
        
        return (
          <button
            onClick={onClick}
            className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
          >
            {icon && <span className="mr-2">{icon}</span>}
            {children}
          </button>
        );
      };
      
      // Custom Select component
      const Select = ({ options, value, onChange, className = '' }) => (
        <div className="relative">
          <select
            value={value}
            onChange={e => onChange(e.target.value)}
            className={`appearance-none bg-gray-700 border border-gray-600 text-gray-200 py-2 px-3 pr-8 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${className}`}
          >
            {options.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-400">
            <ChevronDown size={16} />
          </div>
        </div>
      );
  
    return (
      <div className="space-y-6 p-6 bg-gray-900 rounded-xl shadow-xl max-w-7xl mx-auto">
      {/* Dashboard Header */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold text-white mb-1">Authentication Dashboard</h1>
          <p className="text-gray-400">Monitor user authentication activity and security events</p>
        </div>
        
        <div className="flex items-center gap-3">
          <div className="text-sm text-gray-400 flex items-center">
            <Clock size={16} className="mr-2" />
            Auto-refresh: 
          </div>
          <Select
            value={refreshInterval}
            onChange={(val) => setRefreshInterval(Number(val))}
            options={[
              { value: 15, label: '15s' },
              { value: 30, label: '30s' },
              { value: 60, label: '1m' },
              { value: 300, label: '5m' }
            ]}
            className="w-20"
          />
          <Button 
            variant="secondary" 
            size="md" 
            onClick={fetchData} 
            icon={<RefreshCw size={16} className={loading ? 'animate-spin' : ''} />}
          >
            Refresh
          </Button>
        </div>
      </div>
  
      {/* Summary Stats */}
      {summaryStats && Object.keys(summaryStats).length > 0 ? (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <StatCard 
            title="Total Users" 
            value={summaryStats.all_users} 
            icon={<Users className="text-blue-400 w-6 h-6" />} 
            color="text-white" 
            trend={0.05}
            subtext="↑ 5% this month"
          />
          
          <StatCard 
            title="Active Users" 
            value={summaryStats.active_users} 
            icon={<UserCheck className="text-green-400 w-6 h-6" />} 
            color="text-green-400" 
            trend={0.12}
            subtext={`${Math.round((summaryStats.active_users / summaryStats.all_users) * 100)}% of total users`}
          />
          
          <StatCard 
            title="Success Rate" 
            value={`${summaryStats.total_attempts > 0 ? (summaryStats.login_success / summaryStats.total_attempts * 100).toFixed(1) : 0}%`} 
            icon={<Shield className="text-blue-400 w-6 h-6" />} 
            color="text-blue-400" 
            trend={0.02}
            subtext={`${summaryStats.login_success} successful logins`}
        />
          
          <StatCard 
            title="Failed Attempts" 
            value={summaryStats.login_failure} 
            icon={<AlertCircle className="text-red-400 w-6 h-6" />} 
            color="text-red-400" 
            trend={-0.08}
            subtext={`${summaryStats.login_failure} suspicious activities`}
          />
        </div>
      ) : (
        <div className="bg-gray-800 rounded-lg p-6 text-gray-400 flex items-center justify-center">
          <RefreshCw size={20} className="animate-spin mr-2" /> Loading summary statistics...
        </div>
      )}
      
      {/* Filters and Search */}
      <div className="bg-gray-800 rounded-lg p-6">
        <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4">
          <h3 className="text-xl font-semibold text-gray-100 flex items-center gap-2">
            <Clock size={24} className="text-gray-400" />
            Authentication Activity Log
          </h3>
          
          <div className="flex flex-wrap items-center gap-3">
            <div className="relative flex-grow max-w-md">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Search size={16} className="text-gray-400" />
              </div>
              <input
                type="text"
                placeholder="Search by user, IP, device..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full bg-gray-700 border border-gray-600 text-gray-100 py-2 pl-10 pr-4 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            
            <Button 
              variant="secondary" 
              onClick={() => {}} 
              icon={<Filter size={16} />}
            >
              Filters
            </Button>
            
            <Button 
              variant="ghost" 
              onClick={() => {}} 
              icon={<Download size={16} />}
            >
              Export
            </Button>
          </div>
        </div>
        
        {/* Filter bar */}
        <div className="flex flex-wrap gap-3 mb-4">
          <Select
            value={filterOptions.status}
            onChange={(val) => setFilterOptions({...filterOptions, status: val})}
            options={[
              { value: 'all', label: 'All Status' },
              { value: 'success', label: 'Success' },
              { value: 'failed', label: 'Failed' }
            ]}
          />
          
          <Select
            value={filterOptions.timeRange}
            onChange={(val) => setFilterOptions({...filterOptions, timeRange: val})}
            options={[
              { value: '24h', label: 'Last 24 Hours' },
              { value: '7d', label: 'Last 7 Days' },
              { value: '30d', label: 'Last 30 Days' },
              { value: 'all', label: 'All Time' }
            ]}
          />
          
          <Select
            value={filterOptions.sortBy}
            onChange={(val) => setFilterOptions({...filterOptions, sortBy: val})}
            options={[
              { value: 'timestamp', label: 'Sort by Time' },
              { value: 'user', label: 'Sort by User' },
              { value: 'status', label: 'Sort by Status' }
            ]}
          />
          
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setFilterOptions({
              ...filterOptions, 
              sortDirection: filterOptions.sortDirection === 'asc' ? 'desc' : 'asc'
            })}
            className="px-2"
          >
            {filterOptions.sortDirection === 'asc' ? '↑ Asc' : '↓ Desc'}
          </Button>
        </div>
        
       {/* Activity Log Table */}
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="text-left border-b border-gray-700">
                <th className="pb-3 text-gray-400 font-medium">#</th> {/* Added Index column */}
                <th className="pb-3 text-gray-400 font-medium">Time</th>
                <th className="pb-3 text-gray-400 font-medium">User</th>
                <th className="pb-3 text-gray-400 font-medium">Status</th>
                <th className="pb-3 text-gray-400 font-medium">IP Address</th>
                <th className="pb-3 text-gray-400 font-medium">Device</th>
                <th className="pb-3 text-gray-400 font-medium">User Role</th>
                <th className="pb-3 text-gray-400 font-medium">Location</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={8} className="text-center py-8 text-gray-400"> {/* Updated colSpan for added Index column */}
                    <RefreshCw size={24} className="animate-spin mx-auto mb-2" />
                    Loading activity logs...
                  </td>
                </tr>
              ) : paginatedLogs.length === 0 ? (
                <tr>
                  <td colSpan={8} className="text-center py-8 text-gray-400"> {/* Updated colSpan for added Index column */}
                    No login activity found matching your filters
                  </td>
                </tr>
              ) : (
                paginatedLogs.map((log, index) => {
                  const { relativeTime, absoluteTime } = formatTime(log.timestamp);
                  const status = getStatusDisplay(log);
                  
                  // Calculate the index based on current page and items per page
                  const currentIndex = (currentPage - 1) * itemsPerPage + index + 1;

                  return (
                    <tr key={log.id} className="border-b border-gray-700 hover:bg-gray-750">
                      <td className="py-4 text-gray-300">{currentIndex}</td> {/* Displaying the calculated index */}
                      <td className="py-4 text-gray-300" title={absoluteTime}>
                        {relativeTime}
                      </td>
                      <td className="py-4">
                        <div className="font-medium text-gray-100">
                          {log.email}
                        </div>
                      </td>
                      <td className="py-4">
                        <div className="flex items-center gap-2">
                          <span className={`px-3 py-1 rounded-full text-xs font-medium ${status.badgeClass}`}>
                            {status.text}
                          </span>
                          {status.icon}
                        </div>
                      </td>
                      <td className="py-4 text-gray-300 font-mono text-sm">
                        {log.ip_address}
                      </td>
                      <td className="py-4 text-gray-300">
                        <div className="flex flex-col">
                          <span>{log.browser}</span>
                          <span className="text-xs text-gray-500">{log.operating_system} • {log.device_type}</span>
                        </div>
                      </td>
                      <td className="py-4 text-gray-300">
                        {log.roles}
                      </td>
                      <td className="py-4 text-gray-300">
                        {log.location}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
        
        {/* Pagination */}
        {!loading && filteredAndSortedLogs.length > 0 && (
          <div className="mt-6 flex flex-col sm:flex-row justify-between items-center text-sm text-gray-400">
            <div className="mb-4 sm:mb-0">
              Showing {paginatedLogs.length} of {filteredAndSortedLogs.length} results
            </div>
            
            <div className="flex items-center gap-2">
              <Select
                value={itemsPerPage}
                onChange={(val) => {
                  setItemsPerPage(Number(val));
                  setCurrentPage(1); // Reset to first page when changing items per page
                }}
                options={[
                  { value: 5, label: '5 per page' },
                  { value: 10, label: '10 per page' },
                  { value: 25, label: '25 per page' },
                  { value: 50, label: '50 per page' }
                ]}
                className="w-32"
              />
              
              <div className="flex items-center gap-1">
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                  className={`px-2 ${currentPage === 1 ? 'opacity-50 cursor-not-allowed' : ''}`}
                  disabled={currentPage === 1}
                >
                  Previous
                </Button>
                
                <div className="bg-gray-700 px-3 py-1 rounded">
                  {currentPage} / {totalPages}
                </div>
                
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                  className={`px-2 ${currentPage === totalPages ? 'opacity-50 cursor-not-allowed' : ''}`}
                  disabled={currentPage === totalPages}
                >
                  Next
                </Button>
              </div>
            </div>
          </div>
        )}
        
        {/* Legend */}
        <div className="mt-4 text-sm text-gray-400 flex flex-wrap items-center gap-4">
          <div className="flex items-center gap-2">
            <span className="w-3 h-3 bg-green-400 rounded-full"></span> Success
          </div>
          <div className="flex items-center gap-2">
            <span className="w-3 h-3 bg-red-400 rounded-full"></span> Failed
          </div>
          <div className="flex items-center gap-2">
            <span className="w-3 h-3 bg-yellow-400 rounded-full"></span> Suspicious
          </div>
          <div className="flex items-center gap-2">
            <span className="w-3 h-3 bg-blue-400 rounded-full"></span> New User
          </div>
        </div>
      </div>
    </div>
      
    );
  };
  

// State for confirmation modals
const [confirmationModal, setConfirmationModal] = useState({
  show: false,
  type: null, // 'delete', 'reset', 'terminate'
  userId: null,
  title: '',
  message: '',
  confirmText: '',
  confirmAction: null,
  confirmButtonClass: '',
});
const [sortBy, setSortBy] = useState('name'); // Modify default value as needed


const closeConfirmationModal = () => {
  setConfirmationModal(prev => ({ ...prev, show: false }));
};




  const renderUserManagement = () => {
    
  
    return (
      <div className="space-y-6">
        {/* Dashboard Header */}
        <div className="flex justify-between items-center">
          <h2 className="text-2xl font-bold text-gray-100">User Administration</h2>
          <div className="flex items-center space-x-2">
            <span className="text-sm text-gray-400">Last updated: {new Date().toLocaleTimeString()}</span>
            <button 
              onClick={() => window.location.reload()} 
              className="p-2 bg-gray-700 rounded-full hover:bg-gray-600 transition-colors"
              title="Refresh Data"
            >
              <RefreshCw size={16} className="text-gray-300" />
            </button>
          </div>
        </div>
  
        {/* Summary Statistics with Improved Visual Appeal */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          {[
            { label: 'Total Users', value: summaryStats.all_users, icon: Users, color: 'white', bgColor: 'from-violet-900 to-indigo-900' },
            { label: 'Active Users', value: summaryStats.active_users, icon: UserCheck, color: 'green-400', bgColor: 'from-green-900 to-emerald-900' },
            { label: 'Successful Logins', value: summaryStats.login_success, icon: Lock, color: 'blue-400', bgColor: 'from-blue-900 to-cyan-900' },
            { label: 'Failed Logins', value: summaryStats.login_failure, icon: Shield, color: 'red-400', bgColor: 'from-red-900 to-rose-900' },
          ].map((stat, index) => (
            <div key={index} className={`bg-gradient-to-br ${stat.bgColor} p-5 rounded-lg shadow-lg transition-all hover:scale-[1.02]`}>
              <div className="flex justify-between items-center">
                <div>
                  <div className="text-gray-300 text-sm">{stat.label}</div>
                  <div className={`text-2xl font-bold text-${stat.color} mt-1`}>{stat.value}</div>
                </div>
                <div className={`text-${stat.color} bg-gray-800 bg-opacity-60 p-3 rounded-full`}>
                  <stat.icon size={24} />
                </div>
              </div>
            </div>
          ))}
        </div>
  
        {/* User Management Section with Enhanced UI */}
        <div className="bg-gray-800 rounded-lg shadow-lg overflow-hidden">
          {/* Header with Better Spacing and Organization */}
          <div className="border-b border-gray-700 p-6">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-3">
              <h3 className="text-xl font-semibold text-gray-100 flex items-center">
                <Users size={20} className="mr-2" />
                User Management
              </h3>
              
              <button
                onClick={handleOpenModal}
                className="px-4 py-2.5 bg-blue-600 hover:bg-blue-700 transition-colors rounded-md flex items-center gap-2 shadow-md">
                <UserPlus size={18} />
                <span>Add User</span>
              </button>
            </div>
            
            {/* Search and Filter Controls with Better Layout */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
              <form onSubmit={handleSearch} className="flex col-span-2">
                <div className="relative flex-grow">
                  <input
                    type="text"
                    placeholder="Search by name, email or role..."
                    className="w-full bg-gray-700 text-white pl-10 pr-4 py-2.5 rounded-l-md focus:outline-none focus:ring-2 focus:ring-blue-500 border border-gray-600"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <Search size={18} className="text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2" />
                </div>
                <button 
                  type="submit"
                  className="bg-blue-600 px-4 py-2.5 rounded-r-md hover:bg-blue-700 transition-colors"
                >
                  Search
                </button>
              </form>
  
              <div className="flex gap-3">
                <select
                  className="bg-gray-700 text-white px-4 py-2.5 rounded-md border border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 flex-grow"
                  value={filterActive}
                  onChange={(e) => setFilterActive(e.target.value)}
                >
                  <option value="all">All Users</option>
                  <option value="active">Active Only</option>
                  <option value="inactive">Inactive Only</option>
                </select>
                
                <select
                  className="bg-gray-700 text-white px-4 py-2.5 rounded-md border border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 flex-grow"
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)} 
                >
                  <option value="name">Sort by Name</option>
                  <option value="email">Sort by Email</option>
                  <option value="created">Sort by Created Date</option>
                  <option value="login">Sort by Last Login</option>
                </select>
              </div>
            </div>
          </div>
  
          <AddUserModal
            isOpen={isModalOpen}
            onClose={handleCloseModal}
            //onSubmit={handleSubmit}
          />
  
          {/* Enhanced Users Table */}
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="text-left bg-gray-900">
                  {/* Existing columns */}
                  <th className="px-6 py-4 text-gray-400 font-medium">User</th>
                  <th className="px-6 py-4 text-gray-400 font-medium">Status</th>
                  <th className="px-6 py-4 text-gray-400 font-medium">Created At</th>
                  <th className="px-6 py-4 text-gray-400 font-medium">Last Login</th>
                  
                  {/* New columns for Roles and Tools */}
                  <th className="px-6 py-4 text-gray-400 font-medium">Roles</th>
                  <th className="px-6 py-4 text-gray-400 font-medium">Tools</th>
                  
                  <th className="px-6 py-4 text-gray-400 font-medium">Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.length > 0 ? (
                  users.map(user => (
                    <tr key={user.id} className="border-b border-gray-700 hover:bg-gray-750">
                      <td className="px-6 py-4 whitespace-nowrap overflow-hidden text-ellipsis">
                        <div className="flex items-center">
                          <div className="flex-shrink-0 h-10 w-10 bg-gray-700 rounded-full flex items-center justify-center mr-3">
                            <span className="text-lg font-medium text-gray-300">
                              {`${user.first_name.charAt(0)}${user.last_name.charAt(0)}`}
                            </span>
                          </div>
                          <div>
                            <div className="font-medium text-gray-100">
                              {user.first_name} {user.last_name}
                            </div>
                            <div className="text-sm text-gray-400">
                              <span className="block overflow-hidden truncate">{user.email}</span>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                          user.is_active 
                            ? 'bg-green-900 text-green-300'
                            : 'bg-red-900 text-red-300'
                        }`}>
                          {user.is_active ? 'Active' : 'Inactive'}
                        </span>
                      </td>
                      <td className="px-6 py-4 text-gray-300 whitespace-nowrap">
                        {new Date(user.created_at).toLocaleDateString('en-US', {
                          year: 'numeric',
                          month: 'short',
                          day: 'numeric'
                        })}
                      </td>
                      <td className="px-6 py-4 text-gray-300 whitespace-nowrap">
                        {user.last_login 
                          ? new Date(user.last_login).toLocaleDateString('en-US', {
                              year: 'numeric',
                              month: 'short',
                              day: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit'
                            })
                          : <span className="text-gray-500">Never</span>}
                      </td>
                      
                      {/* New Roles column */}
                      <td className="px-6 py-4">
                        <div className="flex flex-wrap">
                          {user.roles.length > 0 ? (
                            user.roles.map(role => (
                              <span key={role} className="px-3 py-1 bg-gray-700 text-gray-300 rounded-full text-xs mr-1">
                                {role}
                              </span>
                            ))
                          ) : (
                            <span className="text-gray-500">No Roles</span>
                          )}
                        </div>
                      </td>
                      
                      {/* New Tools column */}
                      <td className="px-6 py-4">
                        <div className="flex flex-wrap">
                          {user.tools.length > 0 ? (
                            user.tools.map(tool => (
                              <span key={tool} className="px-3 py-1 bg-gray-600 text-gray-300 rounded-full text-xs mr-1">
                                {tool}
                              </span>
                            ))
                          ) : (
                            <span className="text-gray-500">No Tools</span>
                          )}
                        </div>
                      </td>
                      
                      <td className="px-6 py-4">
                        <div className="flex space-x-2">
                          <button
                            onClick={() => handleEditUser(user)}
                            className="p-1.5 hover:bg-gray-700 text-gray-300 hover:text-white rounded transition-colors"
                            title="Edit User"
                          >
                            <Edit size={18} />
                          </button>
                          <button
                            className="p-1.5 hover:bg-yellow-800 text-gray-300 hover:text-yellow-300 rounded transition-colors"
                            title="Reset Password"
                            onClick={() => handleResetPassword(user.id)}
                          >
                            <Key size={18} />
                          </button>
                          <button
                            className="p-1.5 hover:bg-red-800 text-gray-300 hover:text-red-300 rounded transition-colors"
                            title="Terminate Session"
                            onClick={() => handleTerminateSession(user.id)}
                          >
                            <UserX size={18} />
                          </button>
                          <button
                            className="p-1.5 hover:bg-red-900 text-gray-300 hover:text-red-300 rounded transition-colors"
                            title="Delete User"
                            onClick={() => handleDeleteUser(user.id)}
                          >
                            <Trash2 size={18} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="px-6 py-8 text-center text-gray-400">
                      <div className="flex flex-col items-center">
                        <UserX size={36} className="mb-3 text-gray-500" />
                        <p>No users found matching your criteria</p>
                        {searchTerm && (
                          <button 
                            onClick={() => setSearchTerm('')}
                            className="mt-3 text-blue-400 hover:text-blue-300"
                          >
                            Clear search
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          
          <UserEditModal 
            user={currentUser}
            isOpen={isEditModalOpen}
            onClose={() => setIsEditModalOpen(false)}
            onSave={handleSaveUser}
            roles={availableRoles}  // Array of {id, name} objects
            tools={availableTools} 
          />
  
          {/* Enhanced Pagination with Page Size Control */}
          <div className="px-6 py-4 bg-gray-850 border-t border-gray-700 flex flex-col sm:flex-row justify-between items-center gap-4">
            <div className="flex items-center text-sm text-gray-400">
              <span>Showing </span>
              <select 
                className="mx-2 bg-gray-700 text-white px-2 py-1 rounded-md border border-gray-600"
                value={pageSize}
                //onChange={(e) => setPageSize(Number(e.target.value))}
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              <span>of {} users</span>
            </div>
            
            <div className="flex items-center gap-3">
              <div className="text-sm text-gray-400">
                Page {currentPage} of {totalPages}
              </div>
              <div className="flex">
                <button
                  onClick={() => setCurrentPage(1)}
                  disabled={currentPage === 1}
                  className="p-2 bg-gray-700 rounded-l-md disabled:opacity-50 hover:bg-gray-600 transition-colors"
                  title="First Page"
                >
                  <ChevronsLeft size={18} className="text-gray-300" />
                </button>
                <button
                  onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                  disabled={currentPage === 1}
                  className="p-2 bg-gray-700 disabled:opacity-50 hover:bg-gray-600 transition-colors"
                  title="Previous Page"
                >
                  <ChevronLeft size={18} className="text-gray-300" />
                </button>
                <button
                  onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                  disabled={currentPage === totalPages}
                  className="p-2 bg-gray-700 hover:bg-gray-600 transition-colors"
                  title="Next Page"
                >
                  <ChevronRight size={18} className="text-gray-300" />
                </button>
                <button
                  onClick={() => setCurrentPage(totalPages)}
                  disabled={currentPage === totalPages}
                  className="p-2 bg-gray-700 rounded-r-md disabled:opacity-50 hover:bg-gray-600 transition-colors"
                  title="Last Page"
                >
                  <ChevronsRight size={18} className="text-gray-300" />
                </button>
              </div>
            </div>
          </div>
        </div>
  
        {/* Enhanced Toast Notifications */}
        {showSuccess && (
        <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
          
            <div className="max-w-md bg-green-900 text-green-100 p-4 rounded-lg shadow-lg flex items-start gap-3 animate-slide-up">
              <div className="bg-green-800 p-2 rounded-full">
                <CheckCircle size={20} className="text-green-300" />
              </div>
              <div className="flex-1">
                <h5 className="font-semibold mb-1">Success</h5>
                <p className="text-sm text-green-200">{successMessage}</p>
              </div>
              <button 
                onClick={() => setShowSuccess(false)}
                className="text-green-300 hover:text-white"
              >
                <X size={18} />
              </button>
            </div>
            </div>
          )}
          
          {showError && (
            <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
            <div className="max-w-md bg-red-900 text-red-100 p-4 rounded-lg shadow-lg flex items-start gap-3 animate-slide-up">
              <div className="bg-red-800 p-2 rounded-full">
                <AlertTriangle size={20} className="text-red-300" />
              </div>
              <div className="flex-1">
                <h5 className="font-semibold mb-1">Error</h5>
                <p className="text-sm text-red-200">{errorMessage}</p>
              </div>
              <button 
                onClick={() => setShowError(false)}
                className="text-red-300 hover:text-white"
              >
                <X size={18} />
              </button>
            </div>
            </div>
          )}
    
  
        {/* Universal Confirmation Modal */}
        {confirmationModal.show && (
          <div className="fixed inset-0 bg-black bg-opacity-70 backdrop-blur-sm flex items-center justify-center z-50 p-4">
            <div className="bg-gray-800 rounded-lg max-w-md w-full shadow-xl transform transition-all animate-fade-in">
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-100 mb-2">{confirmationModal.title}</h3>
                <p className="text-gray-300 mb-6">{confirmationModal.message}</p>
                <div className="flex justify-end gap-3">
                  <button
                    className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-md transition-colors"
                    onClick={closeConfirmationModal}
                  >
                    Cancel
                  </button>
                  <button
                    className={`px-4 py-2 ${confirmationModal.confirmButtonClass} text-white rounded-md transition-colors`}
                    onClick={() => {
                      confirmationModal.confirmAction();
                      closeConfirmationModal();
                    }}
                  >
                    {confirmationModal.confirmText}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

 


return (
    <div className="flex h-screen bg-gray-900 text-gray-300">
      {/* Sidebar */}
      <div 
        className={`${sidebarCollapsed ? 'w-20' : 'w-64'} bg-gray-800 border-r border-gray-700 transition-all duration-300 flex flex-col`}
      >
        <div className={`${sidebarCollapsed ? 'justify-center' : 'justify-between'} flex items-center p-6`}>
          {!sidebarCollapsed && <h1 className="text-xl font-bold text-white">SSO Admin</h1>}
          {sidebarCollapsed && <div className="text-blue-500 font-bold text-2xl">SA</div>}
          <button 
            onClick={toggleSidebar} 
            className="text-gray-400 hover:text-white transition-colors"
          >
            {sidebarCollapsed ? <Menu size={20} /> : <ChevronLeft size={20} />}
          </button>
        </div>
        
        <nav className="px-4 py-2 flex-1">
          <ul className="space-y-2">
            {menuItems.map(item => (
              <li key={item.id}>
                <button
                  onClick={() => setActiveSection(item.id)}
                  className={`w-full flex items-center gap-3 px-4 py-3 rounded-md transition-colors
                    ${activeSection === item.id ? 'bg-blue-600 text-white' : 'hover:bg-gray-700'}`}
                >
                  <div className={sidebarCollapsed ? 'mx-auto' : ''}>
                    {item.icon}
                  </div>
                  {!sidebarCollapsed && <span>{item.label}</span>}
                </button>
              </li>
            ))}
          </ul>
        </nav>
        
        <div className="p-4 border-t border-gray-700">
          {!sidebarCollapsed && (
            <div className="flex items-center gap-3 px-4 py-2">
             {currentUser ? (
                <>
                    <Avatar firstName={currentUser.first_name} lastName={currentUser.last_name} />
                    <div className="flex flex-col">
                        <span className="text-sm font-medium">{currentUser.first_name} {currentUser.last_name}</span>
                        <span className="text-xs text-gray-400">{currentUser.role}</span>
                    </div>
                </>
            ) : (
                <span className="text-sm font-medium">Loading...</span>
            )}
            </div>
          )}
          {sidebarCollapsed && (
            <div className="flex justify-center">
              {currentUser ? (
                <>
                    <Avatar firstName={currentUser.first_name} lastName={currentUser.last_name} />                    
                </>
            ) : (
                <span className="text-sm font-medium">...</span>
            )}
            </div>
          )}
        </div>
      </div>
      {/* Main content */}
  <div className="flex-1 flex flex-col overflow-hidden">
    {/* Top navigation */}
    <header className="bg-gray-800 border-b border-gray-700 shadow-md">
      <div className="flex items-center justify-between px-6 py-4">
        <div className="flex-1 flex items-center">
          <div className="relative max-w-md w-full">
            <input
              type="text"
              placeholder="Search..."
              className="w-full bg-gray-700 text-gray-200 pl-10 pr-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <Search size={18} className="absolute left-3 top-2.5 text-gray-400" />
          </div>
        </div>
        
        <div className="flex items-center gap-4">
          <button 
            className={`p-2 hover:bg-gray-700 rounded-md relative ${activeNavItem === 'notifications' ? 'bg-gray-700' : ''}`}
            onClick={toggleNotifications}
          >
            <Bell size={20} />
            <span className="absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full"></span>
          </button>
          <button 
            className={`p-2 hover:bg-gray-700 rounded-md ${isRefreshing ? 'animate-spin' : ''}`}
            onClick={handleRefresh}
          >
            <RefreshCw size={20} />
          </button>
          <button 
            className={`p-2 hover:bg-gray-700 rounded-md ${activeNavItem === 'help' ? 'bg-gray-700' : ''}`}
            onClick={toggleHelp}
          >
            <HelpCircle size={20} />
          </button>
          <div className="h-8 w-px bg-gray-700"></div>
          <div className="flex items-center gap-2">
            {currentUser ? (
                <>
                    <Avatar firstName={currentUser.first_name} lastName={currentUser.last_name} />
                    <div className="flex flex-col">
                        <span className="text-sm font-medium">{currentUser.first_name} {currentUser.last_name}</span>
                        <span className="text-xs text-gray-400">{currentUser.role}</span>
                    </div>
                </>
            ) : (
                <span className="text-sm font-medium">Loading...</span>
            )}
        </div>
          <button 
          onClick={handleLogout} 
          className="p-2 hover:bg-gray-700 rounded-md text-gray-400 hover:text-white"
           
          >
            <LogOut size={20} />
          </button>
        </div>
      </div>
    </header>

    {/* Dropdown panels for nav items */}
    <div className="relative">
      {activeNavItem === 'notifications' && renderNotificationPanel()}
      {activeNavItem === 'help' && renderHelpPanel()}
    </div>

    {/* Main content area */}
    <main className="flex-1 overflow-auto p-6 bg-gray-900">
      <div className="max-w-7xl mx-auto">
        {activeSection === 'dashboard' && AuthLogDashboard()}
        {activeSection === 'users' && renderUserManagement()}
        {activeSection === 'audit' && <LogMonitoring />}        
        {activeSection !== 'dashboard' && activeSection !== 'users' && activeSection !== 'audit' && (
          <div className="flex flex-col items-center justify-center h-64 bg-gray-800 rounded-lg border border-gray-700 shadow-lg">
            <h2 className="text-2xl font-semibold text-white mb-4">
              {menuItems.find(item => item.id === activeSection)?.label}
            </h2>
            <p className="text-gray-400 max-w-md text-center">
              This section is currently in development. Check back soon for updates or contact the administrator for more information.
            </p>
          </div>
        )}
      </div>
    </main>
  </div>
</div>
 );
};

export default SSOAdminPanel;
